import React, {useCallback, useMemo, useTransition} from 'react';
import {
	Link as FluentLink,
	Spinner,
	FontIcon,
	Stack,
	DefaultButton,
	CommandBarButton,
} from '@fluentui/react';
import {AttachmentRef} from 'types';
import {useBaselineDetailsPageTranslations} from '../BaselineDetailsPage/BaselineDetailsPage.utils';

interface Props {
	attachmentRefs: AttachmentRef[];
	showText?: boolean;
}

export function BaselineDownloadBtn({
	attachmentRefs,
	showText,
}: Props): JSX.Element {
	if (attachmentRefs.length === 0) {
		return <Spinner></Spinner>;
	}
	const uri = attachmentRefs.at(0)?.file.uri;

	return (
		<FluentLink target='_blank' download={false} href={uri}>
			<FontIcon iconName='Download' style={{fontSize: 20, paddingLeft: 5}} />
		</FluentLink>
	);
}
